import React from 'react';

const InformationPopup = ({ isOpen, onClose, onConfirm, title, message,color }) => {
  return (
    <>
      {isOpen && (
        <div className="modal is-active">
          <div className="modal-background" onClick={onClose}></div>
          <div className="modal-card">
            <header className="modal-card-head">
              <p className="modal-card-title" style={{color:color}}>{title}</p>
              <button className="delete" aria-label="close" onClick={onClose}></button>
            </header>
            <section className="modal-card-body">
              {message}
            </section>
            <footer className="modal-card-foot">               
              
            </footer>
          </div>
        </div>
      )}
    </>
  );
};

export default InformationPopup;
